import { useColorScheme, useLocalStorage } from '@mantine/hooks';

export type CustomerColorScheme = 'light' | 'dark' | 'auto';
export const CUSTOMER_COLOR_SCHEME_KEY = 'meridian-customer-color-scheme';

function serialize(value: CustomerColorScheme) {
  return value;
}

function deserialize(value: string | undefined): CustomerColorScheme {
  return value === 'light' || value === 'dark' ? value : 'auto';
}

export function useCustomerAppearance() {
  const [preference, setPreference] = useLocalStorage<CustomerColorScheme>({
    key: CUSTOMER_COLOR_SCHEME_KEY,
    defaultValue: 'auto',
    getInitialValueInEffect: false,
    serialize,
    deserialize,
  });
  const systemScheme = useColorScheme('light', { getInitialValueInEffect: false });

  return {
    preference,
    setPreference,
    colorScheme: preference === 'auto' ? systemScheme : preference,
  };
}
